export enum statusPublish {
  ACTIVE = 1,
  INACTIVE = 0,
}

export enum languageEnum {
  TH = "th",
  EN = "en"
}

export const mimeTypes: Record<string, string> = {
  pdf: 'application/pdf',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  txt: 'text/plain',
  json: 'application/json',
};

export enum ROOM_MEETING_TYPE {
  CLASS_ROOM = "ห้องเรียน", // i18n-ignore (data: room type value, translate at render)
  MEETING_ROOM = "ห้องประชุม", // i18n-ignore (data: room type value, translate at render)
}

export const room_meeting_type_data = Object.values(ROOM_MEETING_TYPE).map((list) => ({ label: list, value: list }));

export enum ROOM_MEETING_FILE_TYPE {
  COVER = 'COVER',
  CONTENT = 'CONTENT',
}

export enum STATUS_DATA {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DRAFT = 'draft',
  DELETE = 'delete'
}

export enum LeaveTypeCategory {
  SICK = 'sick',           // ลาป่วย/อาพาธ
  PERSONAL = 'personal',   // ลากิจส่วนตัว
  MATERNITY = 'maternity', // ลาคลอดบุตร
}

// รายการหมวดหมู่การลาสำหรับ dropdown (แสดงครบทุกตัวตาม enum)
export const leave_type_category_data = [
  { value: LeaveTypeCategory.SICK, label: 'ลาป่วย/อาพาธ' }, // i18n-ignore (translated at render: FormComponent t(item.label))
  { value: LeaveTypeCategory.PERSONAL, label: 'ลากิจส่วนตัว' }, // i18n-ignore (translated at render: FormComponent t(item.label))
  { value: LeaveTypeCategory.MATERNITY, label: 'ลาคลอดบุตร' }, // i18n-ignore (translated at render: FormComponent t(item.label))
];